const SVG_NS = 'http://www.w3.org/2000/svg';

/**
 * Factory pro vytváření SVG circle elementů
 * Separuje logiku vytváření DOM od event handlerů
 */
export default class SVGCircleFactory {
  /**
   * Vytvoří SVG circle element (bez event handlerů)
   * @param {Object} config - konfigurace círclu
   * @param {string} config.id - ID elementu
   * @param {number} config.cx - X souřadnice středu
   * @param {number} config.cy - Y souřadnice středu
   * @param {number} config.r - poloměr (default: 8)
   * @param {string} config.color - barva (CSS třída)
   * @param {Object} config.dataSvgResolution - rozlišení SVG {width, height}
   * @param {boolean} config.clone - je to klon? (default: false)
   * @returns {SVGCircleElement}
   */
  static create({
    id,
    cx,
    cy,
    r = 8,
    color = 'blue',
    dataSvgResolution = null,
    clone = false,
  }) {
    const circle = document.createElementNS(SVG_NS, 'circle');

    circle.setAttribute('data-svg-type', 'circle');
    circle.setAttribute('data-svg-circle', '');
    circle.setAttribute('cx', cx);
    circle.setAttribute('cy', cy);
    circle.setAttribute('r', r);
    circle.classList.add('svg-circle', 'unselectable');

    if (id) circle.id = id;

    if (color) circle.classList.add(color);

    if (dataSvgResolution && (dataSvgResolution.width || dataSvgResolution.height)) {
      circle.setAttribute(
        'data-svg-resolution',
        `${dataSvgResolution.width || 0}, ${dataSvgResolution.height || 0}`,
      );
    }

    if (clone) {
      circle.setAttribute('data-svg-clone', 'true');
    }

    return circle;
  }
}
